import Button from "@pathwright/ui/src/components/button/Button"
import Pathicon from "@pathwright/ui/src/components/pathicon/Pathicon"
import FilePickerUpload from "lib/core/components/file-picker-upload/FilePickerUpload"

const Uploader = ({ uploading, error, mediaType, pickFile }) => (
  <Button
    onClick={pickFile}
    styleType="empty"
    style={{ height: 50 }}
    color="#666"
    stretch={true}
  >
    <Pathicon icon="plus-circle" />
    {` Add Attachment\
`}
  </Button>
)

const DownloadsAdd = ({ onAdd }) => (
  <div className="DownloadsListAdd">
    <FilePickerUpload
      previewer={() => false}
      uploader={Uploader}
      mediaType="file"
      onFileUploaded={(file) => {
        const { filename, url, mimetype } = file
        const downloadData = {
          name: filename,
          file_url: url,
          mimetype
        }
        return onAdd(downloadData)
      }}
    />
  </div>
)

DownloadsAdd.displayName = "DownloadsAdd"

export default DownloadsAdd
